// ====================================================
// src/components/block/liveStreamManagement/enchainements/directionUtils.ts
//
// Partagé entre les enchaînements à direction (Poussé, Recouvrement) : une
// config { angleDeg } et la conversion en vecteur de déplacement écran.
// ====================================================

export interface DirectionConfig {
  /** 0 = haut, sens horaire (90 = droite, 180 = bas, 270 = gauche). */
  angleDeg: number;
}

export const DEFAULT_DIRECTION_CONFIG: DirectionConfig = { angleDeg: 270 };

/**
 * Vecteur de déplacement plein cadre pour `angleDeg`, mis à l'échelle par
 * largeur/hauteur du canvas (chaque axe parcouru une fois à p=1). Simplifié
 * pour les angles obliques (l'image quitte le cadre par son axe le plus
 * proche, pas nécessairement par la diagonale) — suffisant visuellement.
 */
export function directionOffset(angleDeg: number, width: number, height: number): { x: number; y: number } {
  const rad = (angleDeg * Math.PI) / 180;
  return { x: Math.sin(rad) * width, y: -Math.cos(rad) * height };
}
